type PendingNewPasswordChallenge = {
  email: string;
};

let pendingChallenge: PendingNewPasswordChallenge | null = null;

export const setPendingNewPasswordChallenge = (email: string): void => {
  pendingChallenge = { email: email.trim().toLowerCase() };
};

export const getPendingNewPasswordChallenge =
  (): PendingNewPasswordChallenge | null => pendingChallenge;

export const hasPendingNewPasswordChallenge = (): boolean =>
  pendingChallenge !== null;

export const clearPendingNewPasswordChallenge = (): void => {
  pendingChallenge = null;
};
